import { render, staticRenderFns } from "./IngredientUpdate.vue?vue&type=template&id=581f31e3&scoped=true&"
import script from "./IngredientUpdate.vue?vue&type=script&lang=js&"
export * from "./IngredientUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581f31e3",
  null
  
)

export default component.exports